export const content  = {
  title: "Upcoming Seminars",
  textBody: "Interested in getting a taster of what we teach? Check out when the next seminar is. Join the Discord Server to attend the seminar."
}